import { appApiSlice } from "src/api/app-ApiSlice";
import { GetPaymentStatusResponse } from "src/model/api/v2/data-contracts";
import { TAG_STRIPE_SUBSCRIPTION } from "src/api/api-tags";

export const paymentV2ApiSlice = appApiSlice.injectEndpoints({
    endpoints: builder => ({
        getPaymentStatus: builder.query<GetPaymentStatusResponse, void>({
            query: () => ({
                url: 'v2/user/get-payment-status',
                method: 'GET',
            }),
            providesTags: [{ type: TAG_STRIPE_SUBSCRIPTION }]
        }),
    }),
});

export const {
    useGetPaymentStatusQuery,
} = paymentV2ApiSlice;
